
//-------------------------------------------------------
//  viewport
//
var ua = navigator.userAgent;
if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
  $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
} else {
  $('head').prepend('<meta name="viewport" content="width=1366">');
}

// スクロールしてトップ
$(".pageTop").on('click',function () {
  $('body,html').animate({
      scrollTop: 0
  }, 500);
  return false;
});

//-------------------------------------------------------
//  サイドボタン
//
var targetBtn = $('.bnrWrapper,.pageTop');
targetBtn.hide();
// スクロールが200に達したらボタン表示
$(window).scroll(function () {
  if ($(this).scrollTop() > $(window).height() / 3) {
      targetBtn.fadeIn();
  } else if ($(this).scrollTop() < $(window).height() / 3) {
      targetBtn.fadeOut();
  } else {
    targetBtn.fadeIn();
  }
});

// $(window).on('scroll', function () {
//   const scroll = $(window).scrollTop();
//   const windowHeight = $(window).height();
//   // const windowWidth =$(window).width();
//   // if (windowWidth > 768) {
//     if(scroll > windowHeight) {
//       $('.bnrWrapper,.pageTop').fadeIn().addClass('active');
//     } else {
//       $('.bnrWrapper,.pageTop').fadeOut();
//     }
//   /*} else {
//     if(scroll > windowHeight) {
//       $('.spBnrWrapper').fadeIn().addClass('active');
//     } else {
//       $('.spBnrWrapper').fadeOut();
//     }
//   }*/
// });

//-------------------------------------------------------

  // $(function(){
  //   if (window.matchMedia('(max-width: 767px)').matches) {
  //     let element = document.querySelector('area');
  //     element.coords = '110,2,260,40'; // 属性値の設定（変更）
  //   }})


//-------------------------------------------------------
//  SNSシェアボタン
//

// SNSボタンを追加するエリア
var snsArea = document.getElementById('footer-sns-area');
 
// シェア時に使用する値
var shareUrl = 'https://dontacos.koikeya.co.jp/'; // 現在のページURLを使用する場合 location.href;
var shareText = document.title; // 現在のページタイトルを使用する場合 document.title;
 
generate_share_button(snsArea, shareUrl, shareText);
 
// シェアボタンを生成する関数
function generate_share_button(area, url, text) {
    // シェアボタンの作成
    var twBtn = document.createElement('li');
    twBtn.className = 'twitter-btn';
    var fbBtn = document.createElement('li');
    fbBtn.className = 'facebook-btn';
    var liBtn = document.createElement('li');
    liBtn.className = 'line-btn';
 
    // 各シェアボタンのリンク先
    var twHref = 'https://twitter.com/intent/tweet?text='+encodeURIComponent(text)+'&url='+encodeURIComponent(url);
    var fbHref = 'http://www.facebook.com/share.php?u='+encodeURIComponent(url);
    var liHref = 'https://line.me/R/msg/text/?'+encodeURIComponent(text)+' '+encodeURIComponent(url);
 
    // シェアボタンにリンクを追加
    var clickEv = 'onclick="popupWindow(this.href); return false;"';
    var twLink = '<a href="' + twHref + '" ' + clickEv + '><img src="https://koikeya.co.jp/images/socialmedia/icon_twitter.svg" alt="Twitter"></a>';
    var fbLink = '<a href="' + fbHref + '" ' + clickEv + '><img src="https://koikeya.co.jp/images/socialmedia/icon_facebook.svg" alt="Facebook"></a>';
    var liLink = '<a href="' + liHref + '" target="_blank"><img src="https://koikeya.co.jp/images/socialmedia/icon_line.svg" alt="LINE"></a>';
    twBtn.innerHTML = twLink;
    fbBtn.innerHTML = fbLink;
    liBtn.innerHTML = liLink;
 
    // シェアボタンを表示
    area.appendChild(twBtn);
    area.appendChild(fbBtn);
    area.appendChild(liBtn);
}

// クリック時にポップアップで表示させる関数
function popupWindow(url) {
    window.open(url, '', 'width=580,height=400,menubar=no,toolbar=no,scrollbars=yes');
}

//スマホ動画再生
$(function(){
  var player;
  /* プレーヤー生成 */
  function loadPlayer(videoID) {
    /* 埋め込むオブジェクトを生成（すでにある場合は削除）*/
    if(!player){
      player = new YT.Player(
        'ytplayer',{
          videoId: videoID,   /* YouTube動画ID */
          playerVars: {
            'controls':       1,
            'rel':            0
          },
          events: { /* イベント */
            "onReady": onPlayerReady   /* プレーヤの準備完了時 */
          }
        }
      );
    }else{
      player.loadVideoById(videoID); /* 指定した動画を読み込んで再生（自動再生扱い） */
    }
  }
  function onPlayerReady(event){
     event.target.setVolume(50);   /* 音量調整 */
     event.target.playVideo();   /* 動画再生 */
  }
  /* 指定した動画を再生 */
  $(".p-movie__listBtn > .p-movie__name").on('click',function(){
     loadPlayer($(this).data("yt"));
  });
  $('.p-movie__listBtn > .p-movie__name').on('click',function(){
    $('.p-movie__listBtn > .p-movie__name').removeClass('is-play');
    $(this).addClass('is-play');
    return false;
  });
});

//アニメーション
const loader = ('.js-loader-bg') ,
      loaderItem = ('.js-loader-item') ,
      mainWrap = ('.mainWrap'),
      body = ('body'),
      mv = ('.p-mv'),
      concept = ('.p-concept');

const tl = gsap.timeline();
tl.fromTo(body, .2,
  {
    opacity: 0,
  },
  {
    opacity: 1,
  },
)
.fromTo(loader, 1,
  {
    opacity: 0,
  },
  {
    opacity: 1,
  },
)
.fromTo(loaderItem, .5,
  {
    opacity: 1,
  },
  {
    opacity: 0,
    ease: 'Back.easeInOut'
  },
  '+=2'
)
.fromTo(loader, .8,
  {
    x: '0',
    width: '100%',
  },
  {
    x: '100%',
    display: "none",
    width: '0',
    ease: 'power2.inOut'
  },
)
.fromTo(mainWrap, 1.2,
  {
    height: "100vh",
    overflow: "hidden",
    opacity: 0,
  },
  {
    height: "auto",
    overflow: "initial",
    opacity: 1,
  },
  '-=1.2'
)
.fromTo(mv, 1,
  {
    opacity: 0,
    y: '-2%',
  },
  {
    display: "block",
    opacity: 1,
    visibility: "visible",
    y: -10,
    delay: 1,
    y: '0%',
    ease: 'bounce.out',
  },
  '-=1.2'
)
.fromTo(concept, 1,
  {
    opacity: 0,
  },
  {
    opacity: 1,
  },
  '-=1.2'
)

const fadeInTarget = gsap.utils.toArray(".js-animation-fade-in");
fadeInTarget.forEach(fadeInTarget => {
  gsap.fromTo(fadeInTarget, {
    opacity: 0, // アニメーション開始前は透明
    scale: .9,
  }, {
      ease: "Elastic.easeOut", // イージング
      opacity: 1, // アニメーション後は出現(透過率0)
      scale: 1,
      duration: 1.5, // アニメーション時間
      scrollTrigger: {
        // toggleActions: "play none none reverse", // 上スクロールで戻る
        trigger: fadeInTarget, // アニメーションが始まるトリガーとなる要素
        start: "top-=100 center", // アニメーションの開始位置
      },
    }
  );
});

const delayfadeInTarget = gsap.utils.toArray(".js-animation-delay-fade-in");
delayfadeInTarget.forEach(delayfadeInTarget => {
  gsap.fromTo(delayfadeInTarget, {
    opacity: 0, // アニメーション開始前は透明
    scale: .9,
  }, {
      ease: "Elastic.easeOut", // イージング
      opacity: 1, // アニメーション後は出現(透過率0)
      scale: 1,
      duration: 1.5, // アニメーション時間
      delay: .5, // アニメーション遅延
      scrollTrigger: {
        // toggleActions: "play none none reverse", // 上スクロールで戻る
        trigger: delayfadeInTarget, // アニメーションが始まるトリガーとなる要素
        start: "top center", // アニメーションの開始位置
      },
    }
  );
});

const titleUp = gsap.utils.toArray(".js-animation-title-up");
titleUp.forEach(titleUp => {
  gsap.fromTo(titleUp, {
    opacity: 0, // アニメーション開始前は透明
    y: -50,
  }, {
      ease: "bounce.out", // イージング
      // ease: "Back.easeInOut", // イージング
      y: 0,
      opacity: 1, // アニメーション後は出現(透過率0)
      duration: .8, // アニメーション時間
      scrollTrigger: {
        // toggleActions: "play none none reverse", // 上スクロールで戻る
        trigger: titleUp, // アニメーションが始まるトリガーとなる要素
        start: "top-=50 center", // アニメーションの開始位置
      },
    }
  );
});

gsap.fromTo(
  ".js-bound-imgTitle img", // アニメーションさせる要素
  {
    opacity: 0,
    y: 50, // 20px下に移動
  },
  {
    opacity: 1,
    y: 0, // 位置を戻す
    stagger: .1, // 0.2秒遅れて順番に再生
    duration: 1, // アニメーション時間
    ease: "Elastic.easeInOut", // イージング
    scrollTrigger: {
      trigger: ".js-bound-imgTitle img", // アニメーションが始まるトリガーとなる要素
      start: "top-=120 center"
    },
  }
);